import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function set(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@set/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@set/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@set/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}